import { View } from 'react-native'
import { useSafeKeyboardOpen } from '../../../SafeKeyboardProvider'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

export const SafeBottomSpace = ({ openSpace = 8 }) => {
    const isKeyboardOpen = useSafeKeyboardOpen()
    const insets = useSafeAreaInsets()

    return (
        <View
            style={{
                height: isKeyboardOpen ? openSpace : Math.max(insets.bottom, 8),
            }}
        />
    )
}
